import { Component, ViewChild } from '@angular/core';
import { I18NService } from '../../../shared/i18n/i18n.service';
import { IPlaceValuelistService } from '../../../iPlace/iPlace-valuelist.service';
import { TankLogService } from '../tank-log.service';
import { Tank } from '../Tank';
import { TankService } from '../Tank.service';
import { ItemTagType } from '../../tag/Tag';
import { Globals } from '../../../globals';
import { TagService } from '../../tag/Tag.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { BsDatepickerConfig } from 'ngx-bootstrap';

@Component({
  selector: 'app-tank-historic',
  templateUrl: './tank-historic.component.html',
  styleUrls: ['./tank-historic.component.css']
})
export class TankHistoricComponent {

  dropdownList: any = [];
  iPlaceList: any[] = [];
  iPlaceMap: any[];
  dropdownListTanks: any = [];
  selectedItems: any;
  selectedTanks: any = [];
  dropdownSettings: any = {};
  dropdownTanksSettings: any = {};
  items: any[] = [];
  itemTags: any[] = [];
  tanks: any[] = [];
  tankSeries: Tank[] = [];
  isLoading = false;
  dateRangeFilter: any;
  bsConfig: Partial<BsDatepickerConfig>;
  bsValue: any;
  currentTank: Tank;

  @ViewChild('multiSelect', { static: true }) element;

  constructor(private i18nService: I18NService,
              private iPlaceValuelistService: IPlaceValuelistService,
              private tankLogService: TankLogService,
              private authService: AuthService,
              private tagService: TagService,
              private tankService: TankService,
              private globals: Globals) {

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});
    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    startDate = new Date(endDate.getTime() - (21 * 86400000));
    this.dateRangeFilter = [startDate, endDate];

    if ( (<any> Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>  Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
        previous[current.id] = current;
        return previous;
      }, {});
      this.getStoreTankHistoric();
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any> Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList();
          } else {
            this.dropdownList = this.iPlaceList;
          }
          this.getStoreTankHistoric();
        });
    }

    let groupBy = null;

    if ( globals.tenant == "ecomanager" ) {
      groupBy = "tag";
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList();
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.isLoading = false;

    this.dropdownSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.dropdownTanksSettings = {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'tankId',
      labelKey: 'name',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectTank"),
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      classes: "form-angular2-multiselect tank-select"
    };
  }

  onItemSelect(item: any) {
    this.reloadTanks();
  }

  onTankSelect(item: any) {
    this.reloadItems();
  }

  onItemDeselect(item: any) {
    this.clearFilters();
  }

  onTankDeselect(item: any) {
    this.tanks = [];
  }

  onDateRangeChange(any: any) {
    this.bsValue = any;
    if(this.selectedTanks.length > 0) {
      this.reloadItems();
    }
  }

  clearFilters() {
    this.items = [];
    this.selectedItems = null;
    this.tanks = [];
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.setStoreTankHistoric()
  }

  private getStoreTankHistoric()  {
    let data = localStorage.getItem("tank_historic_"+ this.authService.getUserID());;
    if( data ) {
      if( JSON.parse(data)[0] && JSON.parse(data)[0].length > 0 ) {
        this.items = JSON.parse(data)[0]
          .filter(item => this.iPlaceList.findIndex(iPlace => iPlace.idiPlace == item.idiPlace) != -1);
        this.selectedItems = this.items.map(item => this.iPlaceMap[item.id]);
        this.getTanksByiPlace();
      }
      if( JSON.parse(data)[1] && JSON.parse(data)[1] != null ) {
        this.selectedTanks.push(JSON.parse(data)[1] as any[]);
        this.tanks = this.tanks.filter(item => this.selectedTanks.findIndex(selected => selected.tankId == item.tankId) != -1);
        let newItems = this.selectedTanks.filter(selected => this.tanks.findIndex(item => selected.tankId == item.tankId) == -1);
        this.tanks.push(...newItems);
        this.getTankSeries();
      }
    }
  }

  private setStoreTankHistoric() {
    localStorage.setItem("tank_historic_" + this.authService.getUserID(), JSON.stringify([this.items, this.selectedTanks[0]]));
  }

  private reloadTanks() {
    this.items = this.items.filter(item => this.selectedItems.findIndex(selected => selected.idiPlace == item.idiPlace) != -1);
    let newItems = this.selectedItems.filter(selected => this.items.findIndex(item => selected.idiPlace == item.idiPlace) == -1);
    this.items.push(...newItems);

    this.getTanksByiPlace();
  }

  private reloadItems() {
    this.tanks = this.tanks.filter(item => this.selectedTanks.findIndex(selected => selected.tankId == item.tankId) != -1);
    let newItems = this.selectedTanks.filter(selected => this.tanks.findIndex(item => selected.tankId == item.tankId) == -1);
    this.tanks.push(...newItems);

    this.getTankSeries();
  }

  private getTanksByiPlace() {
    let iPlaceIds = this.selectedItems[0].idiPlace
    this.selectedTanks = [];
    this.dropdownListTanks = [];

    if(iPlaceIds != null) {
      this.tankService.getTanks(iPlaceIds).then(response => {
        this.tanks = response
          .sort((a, b) => a.localTankId < b.localTankId ? -1 : a.localTankId > b.localTankId ? 1 : 0)
          .filter(tank => tank.productId != null);

        this.tanks
          .forEach(tank => {
            tank.name = this.i18nService.get("tank") + " " + tank.localTankId + " - " + this.i18nService.get(tank.productId);
        });
        this.dropdownListTanks = this.tanks;
      });
    } else {
      this.dropdownListTanks = [];
    }
  }

  private getTankSeries() {
    this.isLoading = true;

    if (this.tanks.length > 0) {
      this.currentTank = this.tanks[0];
      let startDate = this.dateRangeFilter[0].getTime();
      let endDate = this.dateRangeFilter[1].getTime() + 86400000;

      this.tankLogService.get(this.tanks[0].tankId, startDate, endDate).then(response => {
        this.isLoading = false;
        this.tankSeries = response;
        this.setStoreTankHistoric();
      }).catch(error => {
        this.isLoading = false;
      });
    } else {
      this.setStoreTankHistoric();
      this.tankSeries = [];
      this.isLoading = false;
    }
  }

  private setGroupedIPlaceList() {
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });
    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.element.settings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any, b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }

}
